module.exports = __webpack_public_path__ + "assets/img/confirm-bell.67208a79.png";